import { render, staticRenderFns } from "./Zhuwen.vue?vue&type=template&id=b2f6f2a8&scoped=true&"
import script from "./Zhuwen.vue?vue&type=script&lang=js&"
export * from "./Zhuwen.vue?vue&type=script&lang=js&"
import style0 from "./Zhuwen.vue?vue&type=style&index=0&id=b2f6f2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f6f2a8",
  null
  
)

export default component.exports